module.exports = __webpack_public_path__ + "static/sys_ph01-6586cdce39be6f1f8e9ba7434b7359f5.jpg";